import React from "react";
import styled from "@emotion/styled";

const Icon = styled.img`
    margin-left:-15px;
    margin-right:5px;
`;

export class SearchIcon extends React.Component {
    constructor(props) {
        super(props);
    }
        
    render() {
        if(!this.props.src || !this.props.show) return null;
        
        return (
            <Icon src={this.props.src} height="16" width="16" alt="icon"/>
        );
    }
}